var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg502Error(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "705px",
    height: "432px",
    viewBox: "0 0 705 432",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.65475 0.358222526 20.3868 0.358222526 20.3868 46.2234636 0.65475 46.2234636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.263570773 0.234199057 44.283 0.234199057 44.283 125.434201 0.263570773 125.434201"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error-pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "502-Bad-gateway-page",
    transform: "translate(-387.000000, -346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_502-error",
    transform: "translate(387.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-",
    fill: "#ECF0F9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    cx: 190.5,
    cy: 225.5,
    r: 190.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    cx: 345.5,
    cy: 178.5,
    r: 178.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    cx: 354.5,
    cy: 308.5,
    r: 102.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    cx: 524,
    cy: 195,
    r: 181
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-16",
    cx: 483.5,
    cy: 237.5,
    r: 162.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-20",
    cx: 229,
    cy: 30,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-20",
    cx: 419,
    cy: 409,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-22",
    cx: 391.5,
    cy: 427.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 211,
    cy: 24,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrows",
    opacity: 0.300000012,
    transform: "translate(142.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    stroke: "#959FC5",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "301.89582 273.04758 301.45662 308.24928 327.25422 308.24928"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-2",
    stroke: "#959FC5",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "117.369 133.82883 81.3627 133.82883 81.3627 296.57493 27.6066 296.57493 27.6066 316.46673"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    stroke: "#D7E2F4",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "117.369 279.95049 117.369 311.39289 209.1591 311.39289 209.1591 188.95059 62.0919 188.95059"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#D7E2F4",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "23.04261 87.10965 117.36891 87.10965 117.36891 180.67995"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    stroke: "#959FC5",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "234.23283 316.46646 234.80073 301.02786 272.83383 301.40856"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.92979,
    y1: 259.84287,
    x2: 61.58439,
    y2: 259.84287,
    id: "Stroke-8",
    stroke: "#959FC5",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(136.800000, 32.924700)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19.8
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    stroke: "#959FC5",
    points: "0.34704 226.91817 24.18174 226.91817 24.18174 107.84817 135.75024 107.84817 135.75024 34.60437 87.57324 34.60437 87.57324 0.37917"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#D7E2F4",
    points: "202.18437 248.8302 202.18437 132.1902 242.75457 132.1902"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-14",
    stroke: "#D7E2F4",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "301.4568 186.92181 301.4568 48.92391 165.546 48.92391 165.546 88.03161 213.7239 88.03161"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-15",
    stroke: "#959FC5",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "209.15937 140.77305 209.15937 188.95005 301.45707 188.95005 301.45707 288.34785"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-16",
    stroke: "#D7E2F4",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "338.98437 281.7549 301.45707 281.7549 301.45707 311.3631"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(0.000000, 0.524700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.72369,85.08555 C-0.24111,83.95605 -0.24111,82.10835 0.72369,80.97975 L7.59699,72.93645 C8.56179,71.80785 10.14039,69.96015 11.10519,68.83065 L17.97849,60.78825 C18.94329,59.65875 19.73259,59.94945 19.73259,61.43535 L19.73259,80.33265 L19.73259,85.73265 L19.73259,104.62995 C19.73259,106.11495 18.94329,106.40565 17.97849,105.27795 L11.10519,97.23375 C10.14039,96.10515 8.56179,94.25745 7.59699,93.12885 L0.72369,85.08555 Z",
    id: "Fill-17",
    fill: "#D7E2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85725,65.30751 C44.89245,64.17801 44.89245,62.33031 45.85725,61.20171 L52.73055,53.15841 C53.69535,52.02981 55.27395,50.18211 56.23875,49.05261 L63.11205,41.00931 C64.07685,39.88071 64.86615,40.17141 64.86615,41.65731 L64.86615,60.55461 L64.86615,65.95461 L64.86615,84.85191 C64.86615,86.33691 64.07685,86.62761 63.11205,85.49991 L56.23875,77.45571 C55.27395,76.32711 53.69535,74.47941 52.73055,73.35081 L45.85725,65.30751 Z",
    id: "Fill-19",
    fill: "#AEBDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.0851,1.09908 C194.2137,0.13428 196.0614,0.13428 197.1909,1.09908 L205.2342,7.97238 C206.3628,8.93718 208.2105,10.51578 209.3391,11.48058 L217.3824,18.35388 C218.511,19.31868 218.2203,20.10798 216.7353,20.10798 L197.838,20.10798 L192.438,20.10798 L173.5407,20.10798 C172.0548,20.10798 171.7641,19.31868 172.8927,18.35388 L180.936,11.48058 C182.0655,10.51578 183.9132,8.93718 185.0418,7.97238 L193.0851,1.09908 Z",
    id: "Fill-21",
    fill: "#AEBDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36838,288.054 C259.23978,289.0179 257.39208,289.0179 256.26258,288.054 L248.21928,281.1798 C247.09068,280.2159 245.24298,278.6364 244.11438,277.6725 L236.07018,270.7983 C234.94158,269.8344 235.23318,269.0451 236.71818,269.0451 L255.61548,269.0451 L261.01548,269.0451 L279.91278,269.0451 C281.39778,269.0451 281.68938,269.8344 280.56078,270.7983 L272.51748,277.6725 C271.38798,278.6364 269.54028,280.2159 268.41168,281.1798 L260.36838,288.054 Z",
    id: "Fill-23",
    fill: "#AEBDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85725,190.94103 C44.89245,189.81153 44.89245,187.96383 45.85725,186.83523 L52.73055,178.79193 C53.69535,177.66333 55.27395,175.81563 56.23875,174.68613 L63.11205,166.64373 C64.07685,165.51423 64.86615,165.80583 64.86615,167.29083 L64.86615,186.18813 L64.86615,191.58813 L64.86615,210.48633 C64.86615,211.97043 64.07685,212.26203 63.11205,211.13343 L56.23875,203.08923 C55.27395,201.96063 53.69535,200.11293 52.73055,198.98523 L45.85725,190.94103 Z",
    id: "Fill-25",
    fill: "#D7E2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74766,85.49955 C232.71246,86.62815 232.71246,88.47585 231.74766,89.60535 L224.87436,97.64775 C223.90956,98.77725 222.33096,100.62495 221.36616,101.75355 L214.49286,109.79685 C213.52806,110.92635 212.73876,110.63475 212.73876,109.14975 L212.73876,90.25155 L212.73876,84.85155 L212.73876,65.95425 C212.73876,64.47015 213.52806,64.17855 214.49286,65.30715 L221.36616,73.35045 C222.33096,74.47995 223.90956,76.32765 224.87436,77.45535 L231.74766,85.49955 Z",
    id: "Fill-27",
    fill: "#D7E2F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(378.900000, 141.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.66365,21.23829 C20.62845,22.36689 20.62845,24.21459 19.66365,25.34409 L12.79035,33.38649 C11.82555,34.51599 10.24695,36.36369 9.28215,37.49229 L2.40885,45.53559 C1.44405,46.66419 0.65475,46.37349 0.65475,44.88759 L0.65475,25.99029 L0.65475,20.59029 L0.65475,1.69299 C0.65475,0.20889 1.44405,-0.08271 2.40885,1.04589 L9.28215,9.08919 C10.24695,10.21869 11.82555,12.06639 12.79035,13.19409 L19.66365,21.23829 Z",
    id: "Fill-29",
    fill: "#D7E2F4",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.92414,296.56539 C287.88894,297.69489 287.88894,299.54259 286.92414,300.67119 L280.05084,308.71449 C279.08604,309.84309 277.50744,311.69079 276.54264,312.82029 L269.66934,320.86359 C268.70454,321.99219 267.91524,321.70149 267.91524,320.21559 L267.91524,301.31829 L267.91524,295.91829 L267.91524,277.02099 C267.91524,275.53599 268.70454,275.24529 269.66934,276.37299 L276.54264,284.41719 C277.50744,285.54579 279.08604,287.39349 280.05084,288.52209 L286.92414,296.56539 Z",
    id: "Fill-32",
    fill: "#959FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85725,261.37134 C44.89245,260.24184 44.89245,258.39414 45.85725,257.26554 L52.73055,249.22224 C53.69535,248.09364 55.27395,246.24594 56.23875,245.11644 L63.11205,237.07314 C64.07685,235.94454 64.86615,236.23524 64.86615,237.72114 L64.86615,256.61844 L64.86615,262.01844 L64.86615,280.91574 C64.86615,282.40074 64.07685,282.69144 63.11205,281.56374 L56.23875,273.51954 C55.27395,272.39094 53.69535,270.54324 52.73055,269.41464 L45.85725,261.37134 Z",
    id: "Fill-34",
    fill: "#959FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62356,16.37091 C222.75216,15.40611 224.59986,15.40611 225.72846,16.37091 L233.77266,23.24421 C234.90126,24.20901 236.74896,25.78761 237.87756,26.75241 L245.92086,33.62571 C247.04946,34.59051 246.75876,35.37981 245.27376,35.37981 L226.37646,35.37981 L220.97646,35.37981 L202.07826,35.37981 C200.59326,35.37981 200.30256,34.59051 201.43116,33.62571 L209.47446,26.75241 C210.60396,25.78761 212.45076,24.20901 213.57936,23.24421 L221.62356,16.37091 Z",
    id: "Fill-36",
    fill: "#959FC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6595,329.84775 C28.5309,330.81255 26.6832,330.81255 25.5546,329.84775 L17.5104,322.97445 C16.3818,322.00965 14.5341,320.43105 13.4055,319.46625 L5.3622,312.59295 C4.2336,311.62815 4.5243,310.83885 6.0093,310.83885 L24.9066,310.83885 L30.3066,310.83885 L49.2048,310.83885 C50.6898,310.83885 50.9805,311.62815 49.8519,312.59295 L41.8086,319.46625 C40.6791,320.43105 38.8323,322.00965 37.7037,322.97445 L29.6595,329.84775 Z",
    id: "Fill-38",
    fill: "#959FC5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-40",
    stroke: "#AEBDED",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "192.38895 281.2302 192.38895 222.9102 338.98455 222.9102 338.98455 85.4487 258.31575 85.4487 258.31575 271.566"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-42",
    stroke: "#AEBDED",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "258.31575 326.22489 258.31575 313.00929 192.38895 313.00929 192.38895 281.23029 37.20735 281.23029 37.20735 157.96809 103.13415 157.96809 103.13415 63.25479 144.21195 63.25479 144.65115 63.25479 65.30625 63.25479"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.92979,
    y1: 321.22044,
    x2: 144.92979,
    y2: 263.98764,
    id: "Stroke-44",
    stroke: "#959FC5",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-46",
    stroke: "#AEBDED",
    strokeWidth: 19.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "258.31575 115.3692 147.76155 115.3692 147.76155 60.5997 194.92425 60.5997 194.92425 14.6169"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.369,
    y1: 182.18358,
    x2: 117.369,
    y2: 261.08478,
    id: "Stroke-48",
    stroke: "#D7E2F4",
    strokeWidth: 19.8,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-218",
    transform: "translate(101.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0126,54.6359 C34.1686,54.6359 44.0226,82.6619 44.0226,117.2349 C44.0226,151.8079 34.1686,179.8339 22.0126,179.8339 C9.8566,179.8339 0.0026,151.8079 0.0026,117.2349 C0.0026,82.6619 9.8566,54.6359 22.0126,54.6359",
    id: "Fill-1",
    fill: "#3D4666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.9501,126.0636 C213.9301,126.1136 213.9201,126.1636 213.9001,126.2136 C212.2001,131.5936 209.1401,136.1236 205.6101,140.4436 C202.7401,143.9536 199.2901,146.7536 195.7001,149.4836 C191.9101,152.3536 187.7301,154.6436 183.3701,156.5036 C176.6701,159.3636 169.8901,161.5636 162.7101,162.8436 C154.5001,164.3036 145.7601,165.5136 137.3901,164.8836 C130.0601,164.3236 122.9301,162.6536 116.5401,158.8836 C111.7401,156.0536 107.5201,152.2136 104.1001,147.8336 C100.5501,143.2736 97.5001,138.5036 94.5501,133.5336 C92.2301,129.6236 89.8801,125.7136 87.1801,122.0536 C87.1701,122.0536 87.1701,122.0426 87.1701,122.0426 C85.0901,119.5136 82.8101,117.1536 80.3001,115.0636 C80.2901,115.0636 80.2901,115.0536 80.2901,115.0536 C80.2801,115.0426 80.2701,115.0426 80.2701,115.0426 C77.9301,113.3836 75.4501,111.9536 72.8501,110.7336 C72.8401,110.7336 72.8201,110.7236 72.8001,110.7136 C70.7501,109.9436 68.6501,109.3336 66.4901,108.9236 C64.7401,108.7836 62.9901,108.7836 61.2401,108.9336 C58.6601,109.4136 56.1501,110.1836 53.7001,111.1436 C53.6701,111.1536 53.6501,111.1636 53.6301,111.1736 C50.3301,112.6736 47.1601,114.4336 44.0101,116.2336 C43.9801,116.2536 43.9501,116.2636 43.9201,116.2836 C35.7901,120.9336 27.7801,125.4836 19.0601,128.9636 C13.3201,131.2636 7.2401,132.8536 1.0701,133.7136 C0.3801,127.6336 0.0001,121.1536 0.0001,114.4136 C0.0001,112.7926 0.0201,111.1936 0.0601,109.6036 C4.4001,108.7336 8.6301,107.4436 12.7401,105.7926 C12.7501,105.7836 12.7701,105.7836 12.7801,105.7736 C20.6801,102.2436 27.9701,97.5936 35.5501,93.4536 C37.7601,92.2536 40.0101,91.1236 42.3001,90.0936 C44.2501,89.2036 46.2201,88.3836 48.2301,87.6436 C52.4501,86.0836 56.8301,85.2836 61.3001,84.9136 C71.3501,84.0736 81.8901,87.5936 90.3001,92.9136 C98.8601,98.3236 105.4001,105.8036 110.8701,114.2336 C114.6801,120.0836 117.8801,126.3536 121.9901,132.0036 C123.4701,133.8136 125.0701,135.4936 126.8401,136.9936 C128.0601,137.8336 129.3301,138.5836 130.6601,139.2336 C132.5901,139.9436 134.5701,140.4536 136.5801,140.8136 L136.6101,140.8136 C142.0501,141.3136 147.6001,140.8936 153.0201,140.2336 C153.0601,140.2236 153.1001,140.2236 153.1401,140.2136 C159.7801,139.2336 166.3401,137.6636 172.5901,135.1936 C176.1501,133.5936 179.5601,131.6736 182.7301,129.3736 C184.7401,127.7136 186.6101,125.8936 188.2901,123.8936 C189.2201,122.5736 190.0801,121.1936 190.7901,119.7436 C190.8001,119.7236 190.8001,119.7036 190.8101,119.6836 C191.6601,116.6036 193.6901,114.2136 196.3201,112.5136 C199.0501,110.7536 202.4901,110.6036 205.5701,111.3036 C208.4301,111.9536 211.2801,114.3236 212.7401,116.8136 C214.3101,119.4936 214.7801,123.0736 213.9501,126.0636",
    id: "Fill-3",
    fill: "#6B76A0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(468.000000, 42.048000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2836127,62.8232 C44.2846,65.6132 44.2266,68.3632 44.0976,71.0632 C42.6936,101.7442 33.4856,125.4282 22.3046,125.434201 C11.1846,125.4402 1.9636,101.9652 0.4776,71.4662 C0.3366,68.6452 0.2646,65.7652 0.263570773,62.8452 C0.2606,57.5252 0.4886,52.3652 0.9256,47.4352 C3.3316,20.3142 11.9616,0.2392 22.2416,0.234199057 C32.4816,0.2292 41.0916,20.1042 43.5756,47.0332 L43.5756,47.0942 L43.5756,47.1032 C44.0376,52.1232 44.2806,57.3932 44.2836127,62.8232",
    id: "Fill-5",
    fill: "#3D4666",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M510.7533,90.9826 C511.1453,96.0076 511.3143,101.2816 511.2403,106.7116 C511.2023,109.5006 511.1053,112.2496 510.9383,114.9476 C509.9173,115.0446 508.8963,115.1196 507.8753,115.1856 C500.3273,115.6726 492.7433,115.1706 485.1963,114.9486 C479.2383,114.7676 473.2783,114.6866 467.3173,114.7356 C461.6563,114.7786 456.0033,114.9426 450.3383,115.2356 C447.1763,115.4026 444.1293,113.7116 441.9073,111.6106 C439.5773,109.4096 438.6003,106.1856 438.5033,103.0746 C438.4133,100.0826 440.0293,96.6936 442.1373,94.6426 C444.4883,92.3536 447.4613,91.4146 450.6643,91.2376 C456.4693,90.9366 462.2923,90.7456 468.1033,90.7136 C468.5533,90.7106 468.9933,90.7066 469.4433,90.7026 C477.6143,90.6726 485.7813,90.9736 493.9483,91.2246 C499.2673,91.3866 504.6253,91.5396 509.9323,91.0506 C510.2123,91.0146 510.4833,90.9686 510.7543,90.9126 L510.7533,90.9726",
    id: "Fill-8",
    fill: "#6B76A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7499,133.4113 C177.7279,118.3433 184.4539,98.7153 190.0399,92.8653 L189.8719,92.5993 C186.7299,84.8943 182.5799,75.9133 182.5799,65.8133 C182.5799,29.4663 201.3759,0.0003 235.8179,0.0003 C270.5209,0.0003 289.0569,29.4663 289.0569,65.8133 C289.0569,75.5893 285.0169,85.0623 282.0629,92.5993 L281.9979,92.8653 C287.5829,98.7153 294.3089,118.3433 274.2869,133.4113 L197.7499,133.4113 Z",
    id: "Fill-10",
    fill: "#828DB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(190.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.263,73.108 L5.457,76.642 C2.996,70.707 -1.42108547e-14,59.501 -1.42108547e-14,51.8 C-1.42108547e-14,23.15 18.263,-8.52651283e-14 47.109,-8.52651283e-14 C60.027,-8.52651283e-14 70.292,4.728 77.674,12.547 C70.841,7.29 61.82,3.883 51.502,2.714 C23.701,-0.435 1.782,28.898 3.258,57.502 C3.502,62.23 5.263,73.108 5.263,73.108",
    id: "Fill-5",
    opacity: 0.049999997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6439,99.3411 C86.6439,102.4411 85.0139,105.1511 82.5639,106.6711 C83.5339,105.2811 84.0929,103.6011 84.0929,101.7811 C84.0929,97.0011 80.2239,93.1311 75.4439,93.1311 C73.7739,93.1311 72.2129,93.6111 70.8829,94.4411 C72.4339,92.1811 75.0429,90.6911 78.0029,90.6911 C82.7739,90.6911 86.6439,94.5611 86.6439,99.3411",
    id: "Fill-11",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6439,99.3411 C28.6439,102.4411 27.0139,105.1511 24.5639,106.6711 C25.5339,105.2811 26.0929,103.6011 26.0929,101.7811 C26.0929,97.0011 22.2239,93.1311 17.4439,93.1311 C15.7739,93.1311 14.2129,93.6111 12.8829,94.4411 C14.4339,92.1811 17.0429,90.6911 20.0029,90.6911 C24.7739,90.6911 28.6439,94.5611 28.6439,99.3411",
    id: "Fill-11",
    opacity: 0.100000001
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.9969,108.8859 C256.9969,113.6599 260.8679,117.5319 265.6429,117.5319 C270.4169,117.5319 274.2889,113.6599 274.2889,108.8859 C274.2889,104.1109 270.4169,100.2399 265.6429,100.2399 C260.8679,100.2399 256.9969,104.1109 256.9969,108.8859",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1898,108.8849 C199.1898,113.6599 203.0608,117.5309 207.8358,117.5309 C212.6098,117.5309 216.4818,113.6599 216.4818,108.8849 C216.4818,104.1109 212.6098,100.2389 207.8358,100.2389 C203.0608,100.2389 199.1898,104.1109 199.1898,108.8849",
    id: "Fill-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1263,109.7414 C212.4773,110.7834 213.6053,111.3434 214.6473,110.9924 C215.6883,110.6414 216.2483,109.5134 215.8973,108.4714 C215.5473,107.4304 214.4183,106.8704 213.3773,107.2204 C212.3353,107.5714 211.7753,108.7004 212.1263,109.7414",
    id: "Fill-16",
    fill: "#525F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4862,110.8341 C271.2032,111.6671 272.4592,111.7621 273.2922,111.0451 C274.1252,110.3281 274.2192,109.0711 273.5032,108.2381 C272.7862,107.4051 271.5292,107.3121 270.6962,108.0281 C269.8632,108.7451 269.7692,110.0011 270.4862,110.8341",
    id: "Fill-18",
    fill: "#525F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9955,138.7775 C256.9955,138.7775 254.7365,226.4805 306.8065,223.1305 C358.2445,219.8205 338.3705,241.4045 383.7815,218.3785",
    id: "Stroke-20",
    stroke: "#6B76A0",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4515,130.6701 C263.4515,130.6701 267.6985,195.3271 307.2485,194.3741 C343.9675,193.4891 314.7695,153.2321 360.3355,154.5591 C398.0695,155.6581 401.9215,147.9231 402.8055,110.3191",
    id: "Stroke-22",
    stroke: "#828DB7",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6776,137.2404 C213.6776,137.2404 232.0456,258.9834 156.7516,261.9104 C113.0366,263.6094 94.2356,227.9964 117.6816,205.8774",
    id: "Stroke-24",
    stroke: "#6B76A0",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(108.000000, 202.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1937,24.6924 C90.4387,24.5704 89.7277,25.0834 89.6057,25.8384 C89.4837,26.5924 89.9957,27.3034 90.7507,27.4254 C91.5057,27.5474 92.2167,27.0354 92.3387,26.2814 C92.4617,25.5264 91.9487,24.8154 91.1937,24.6924",
    id: "Fill-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3197,35.6719 C82.5127,35.3849 81.6267,35.8069 81.3397,36.6129 C81.0517,37.4199 81.4737,38.3079 82.2797,38.5939 C83.0877,38.8809 83.9737,38.4599 84.2607,37.6529 C84.5487,36.8459 84.1267,35.9589 83.3197,35.6719",
    id: "Fill-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5179,44.8574 C72.6589,44.4064 71.5959,44.7364 71.1439,45.5944 C70.6929,46.4544 71.0229,47.5164 71.8819,47.9684 C72.7409,48.4204 73.8039,48.0904 74.2549,47.2314 C74.7069,46.3724 74.3769,45.3094 73.5179,44.8574",
    id: "Fill-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7928,51.0264 C60.8808,50.4094 59.6428,50.6484 59.0258,51.5594 C58.4098,52.4704 58.6478,53.7094 59.5598,54.3264 C60.4708,54.9424 61.7098,54.7044 62.3258,53.7934 C62.9428,52.8814 62.7038,51.6424 61.7928,51.0264",
    id: "Fill-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0126,53.1064 C46.0496,52.3254 44.6356,52.4724 43.8536,53.4364 C43.0726,54.3994 43.2196,55.8134 44.1826,56.5954 C45.1466,57.3774 46.5606,57.2294 47.3426,56.2654 C48.1236,55.3024 47.9756,53.8874 47.0126,53.1064",
    id: "Fill-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9447,51.1826 C29.9287,50.2366 28.3387,50.2926 27.3927,51.3086 C26.4467,52.3236 26.5027,53.9136 27.5187,54.8606 C28.5337,55.8056 30.1237,55.7496 31.0697,54.7346 C32.0167,53.7186 31.9597,52.1286 30.9447,51.1826",
    id: "Fill-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2709,45.748 C17.2029,44.637 15.4369,44.602 14.3259,45.67 C13.2149,46.737 13.1799,48.503 14.2479,49.614 C15.3159,50.726 17.0819,50.76 18.1929,49.692 C19.3039,48.625 19.3389,46.858 18.2709,45.748",
    id: "Fill-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7509,37.4746 C8.6309,36.1996 6.6889,36.0736 5.4139,37.1926 C4.1379,38.3126 4.0109,40.2546 5.1309,41.5306 C6.2509,42.8056 8.1929,42.9326 9.4689,41.8126 C10.7439,40.6926 10.8709,38.7506 9.7509,37.4746",
    id: "Fill-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1429,27.0361 C4.9709,25.5961 2.8529,25.3781 1.4129,26.5501 C-0.0271,27.7221 -0.2451,29.8401 0.9269,31.2801 C2.0989,32.7211 4.2169,32.9371 5.6569,31.7651 C7.0979,30.5941 7.3149,28.4761 6.1429,27.0361",
    id: "Fill-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2074,15.1025 C6.9834,13.4975 4.6894,13.1885 3.0844,14.4135 C1.4794,15.6365 1.1704,17.9305 2.3944,19.5355 C3.6184,21.1405 5.9124,21.4495 7.5174,20.2255 C9.1224,19.0005 9.4314,16.7075 8.2074,15.1025",
    id: "Fill-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7025,2.3476 C15.4265,0.5766 12.9565,0.1776 11.1865,1.4536 C9.4165,2.7296 9.0165,5.1996 10.2925,6.9696 C11.5695,8.7396 14.0385,9.1396 15.8085,7.8636 C17.5785,6.5866 17.9785,4.1176 16.7025,2.3476",
    id: "Fill-46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.1298,132.4543 C207.1298,132.4543 211.5468,173.0053 166.7328,212.1263 C125.8118,247.8493 87.6548,214.0063 74.7148,277.6003",
    id: "Stroke-49",
    stroke: "#828DB7",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8685,138.7775 C231.8685,138.7775 254.0555,191.5045 244.4285,227.4435 C229.4975,283.1855 262.0135,288.4945 284.2435,289.8215",
    id: "Stroke-51",
    stroke: "#6B76A0",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8046,127.0519 C216.5156,132.0099 215.5276,137.0659 214.7056,142.1189 C213.8306,147.5009 213.0846,152.9349 212.7576,158.3809 C212.4636,163.2689 212.7006,168.1699 212.5416,173.0639 C212.3846,177.9189 212.0106,182.7649 211.3646,187.5799 C211.5076,186.5169 211.6496,185.4529 211.7926,184.3909 C210.8156,191.5309 209.0636,198.4729 207.3616,205.4629 C205.5656,212.8379 204.2786,220.4089 204.2346,228.0169 C204.1996,234.0069 204.9926,239.9059 205.8026,245.8299 C205.6596,244.7669 205.5166,243.7029 205.3736,242.6399 C206.4756,250.9039 206.8116,259.3029 205.7356,267.5879 C205.8786,266.5249 206.0216,265.4609 206.1636,264.3989 C205.5066,269.2839 204.3516,274.0999 202.4556,278.6579 C202.8596,277.7029 203.2626,276.7469 203.6656,275.7919 C202.3736,278.8479 200.7566,281.7489 198.7416,284.3879 C199.3676,283.5779 199.9926,282.7699 200.6176,281.9599 C198.9926,284.0559 197.1376,285.9479 195.0436,287.5769 C195.8526,286.9519 196.6616,286.3259 197.4716,285.7009 C195.5546,287.1679 193.4766,288.3869 191.2596,289.3409 C192.2146,288.9379 193.1706,288.5339 194.1256,288.1309 C191.6476,289.1739 189.0526,289.8639 186.3906,290.2299 C187.4536,290.0869 188.5176,289.9439 189.5806,289.8009 C186.3876,290.2169 183.1676,290.1639 179.9776,289.7519 C181.0406,289.8949 182.1046,290.0369 183.1676,290.1809 C179.2986,289.6559 175.5316,288.6139 171.8866,287.2239 C169.1406,286.1749 165.0806,287.0049 162.6396,288.4329 C160.1506,289.8899 157.7766,292.7439 157.1246,295.6049 C156.4256,298.6769 156.5766,302.1249 158.3346,304.8519 L160.2116,307.2809 C161.7086,308.7679 163.4736,309.7959 165.5066,310.3659 C178.7776,315.4319 194.5406,315.7699 206.9756,308.2159 C219.7546,300.4529 227.0536,286.2039 229.1736,271.7339 C229.9466,266.4619 230.4566,261.2229 230.3876,255.8919 C230.3096,249.8399 229.5506,243.8789 228.7286,237.8899 C228.8716,238.9529 229.0146,240.0169 229.1576,241.0799 C228.1766,233.7659 227.8776,226.3869 228.8616,219.0569 C228.7196,220.1199 228.5756,221.1839 228.4336,222.2469 C229.3776,215.3879 231.3796,208.7479 232.8946,202.0069 C235.2476,191.5409 236.4466,180.7999 236.6126,170.0789 C236.6666,166.5689 236.5296,163.0579 236.6946,159.5499 C236.8486,156.2859 237.1826,153.0329 237.6116,149.7949 C237.4686,150.8589 237.3256,151.9219 237.1826,152.9859 C238.0686,146.4189 239.2786,139.8489 240.9476,133.4319 C241.7376,130.3919 241.3326,126.9109 239.7376,124.1859 C238.2806,121.6969 235.4266,119.3229 232.5656,118.6709 C229.4936,117.9709 226.0456,118.1219 223.3196,119.8809 C220.7106,121.5629 218.6026,123.9809 217.8046,127.0519",
    id: "Fill-53",
    fill: "#828DB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    transform: "translate(241.000000, 214.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8251,0.1953 C13.0701,0.0723 12.3591,0.5853 12.2371,1.3403 C12.1151,2.0943 12.6271,2.8053 13.3821,2.9283 C14.1371,3.0503 14.8481,2.5383 14.9701,1.7833 C15.0931,1.0283 14.5801,0.3173 13.8251,0.1953",
    id: "Fill-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2084,13.9297 C7.4014,13.6427 6.5144,14.0647 6.2274,14.8707 C5.9404,15.6777 6.3614,16.5647 7.1684,16.8517 C7.9754,17.1387 8.8624,16.7177 9.1494,15.9097 C9.4374,15.1037 9.0154,14.2167 8.2084,13.9297",
    id: "Fill-57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0062,26.084 C4.1472,25.633 3.0842,25.963 2.6322,26.822 C2.1802,27.681 2.5102,28.743 3.3702,29.195 C4.2292,29.647 5.2922,29.317 5.7432,28.458 C6.1952,27.599 5.8652,26.536 5.0062,26.084",
    id: "Fill-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0848,36.6982 C3.1738,36.0822 1.9348,36.3202 1.3178,37.2312 C0.7018,38.1422 0.9408,39.3822 1.8518,39.9982 C2.7628,40.6142 4.0018,40.3762 4.6178,39.4652 C5.2348,38.5532 4.9958,37.3152 4.0848,36.6982",
    id: "Fill-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3104,45.8105 C4.3474,45.0295 2.9324,45.1765 2.1514,46.1395 C1.3704,47.1035 1.5174,48.5175 2.4804,49.2985 C3.4444,50.0805 4.8584,49.9325 5.6404,48.9695 C6.4214,48.0055 6.2734,46.5915 5.3104,45.8105",
    id: "Fill-63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5492,53.4599 C7.5342,52.5139 5.9442,52.5699 4.9972,53.5859 C4.0512,54.6019 4.1082,56.1909 5.1232,57.1379 C6.1382,58.0839 7.7292,58.0269 8.6752,57.0119 C9.6212,55.9959 9.5652,54.4059 8.5492,53.4599",
    id: "Fill-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6678,59.6865 C12.6008,58.5755 10.8348,58.5405 9.7238,59.6085 C8.6128,60.6755 8.5778,62.4415 9.6448,63.5525 C10.7128,64.6635 12.4788,64.6985 13.5898,63.6305 C14.7008,62.5635 14.7358,60.7965 13.6678,59.6865",
    id: "Fill-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5326,64.5283 C19.4126,63.2533 17.4706,63.1263 16.1956,64.2463 C14.9196,65.3663 14.7936,67.3073 15.9126,68.5833 C17.0326,69.8593 18.9746,69.9853 20.2506,68.8653 C21.5266,67.7463 21.6526,65.8033 20.5326,64.5283",
    id: "Fill-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0092,68.0254 C27.8372,66.5854 25.7192,66.3674 24.2792,67.5394 C22.8392,68.7114 22.6212,70.8294 23.7932,72.2694 C24.9652,73.7104 27.0832,73.9264 28.5232,72.7544 C29.9642,71.5834 30.1812,69.4654 29.0092,68.0254",
    id: "Fill-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9647,70.2158 C37.7407,68.6108 35.4467,68.3018 33.8417,69.5268 C32.2357,70.7498 31.9277,73.0438 33.1517,74.6488 C34.3757,76.2538 36.6697,76.5628 38.2747,75.3388 C39.8797,74.1138 40.1887,71.8208 38.9647,70.2158",
    id: "Fill-73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2645,71.1396 C48.9885,69.3696 46.5185,68.9696 44.7485,70.2456 C42.9785,71.5226 42.5785,73.9926 43.8545,75.7616 C45.1315,77.5316 47.6005,77.9316 49.3705,76.6556 C51.1405,75.3786 51.5405,72.9106 50.2645,71.1396",
    id: "Fill-75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.4379,135.7023 C242.4379,135.7023 244.7599,146.8173 248.8529,175.3513 C255.1479,219.2553 267.9499,200.9983 272.7419,230.2093 C282.0319,286.8353 334.6769,241.2683 340.8709,290.8163",
    id: "Stroke-78",
    stroke: "#828DB7",
    strokeWidth: 24,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-102",
    transform: "translate(275.000000, 217.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1659,0.9551 C1.4109,0.8331 0.6999,1.3461 0.5779,2.1011 C0.4559,2.8551 0.9679,3.5661 1.7229,3.6881 C2.4779,3.8101 3.1889,3.2981 3.3109,2.5441 C3.4339,1.7891 2.9209,1.0781 2.1659,0.9551",
    id: "Fill-80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6869,11.1982 C4.8799,10.9112 3.9929,11.3332 3.7059,12.1392 C3.4189,12.9462 3.8399,13.8332 4.6469,14.1202 C5.4549,14.4072 6.3409,13.9862 6.6279,13.1792 C6.9159,12.3722 6.4939,11.4852 5.6869,11.1982",
    id: "Fill-82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.889,22.2803 C7.03,21.8283 5.968,22.1583 5.515,23.0173 C5.064,23.8773 5.394,24.9393 6.253,25.3913 C7.112,25.8433 8.175,25.5123 8.626,24.6543 C9.078,23.7953 8.748,22.7323 7.889,22.2803",
    id: "Fill-84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.327,30.2764 C12.416,29.6594 11.177,29.8984 10.561,30.8094 C9.944,31.7204 10.183,32.9594 11.094,33.5764 C12.005,34.1924 13.244,33.9544 13.861,33.0434 C14.477,32.1304 14.238,30.8924 13.327,30.2764",
    id: "Fill-86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3959,35.3506 C20.4329,34.5696 19.0189,34.7166 18.2369,35.6796 C17.4559,36.6436 17.6029,38.0576 18.5659,38.8386 C19.5299,39.6206 20.9439,39.4726 21.7259,38.5096 C22.5069,37.5456 22.3589,36.1316 21.3959,35.3506",
    id: "Fill-88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1815,38.6543 C30.1655,37.7083 28.5755,37.7643 27.6295,38.7803 C26.6835,39.7963 26.7395,41.3853 27.7555,42.3323 C28.7705,43.2783 30.3605,43.2213 31.3065,42.2063 C32.2525,41.1913 32.1965,39.6003 31.1815,38.6543",
    id: "Fill-90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7679,41.3398 C40.6999,40.2288 38.9339,40.1938 37.8229,41.2618 C36.7119,42.3288 36.6769,44.0948 37.7449,45.2058 C38.8129,46.3178 40.5789,46.3518 41.6899,45.2838 C42.8009,44.2168 42.8349,42.4498 41.7679,41.3398",
    id: "Fill-92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2411,44.5566 C51.1211,43.2816 49.1791,43.1556 47.9041,44.2746 C46.6281,45.3946 46.5021,47.3366 47.6211,48.6126 C48.7411,49.8876 50.6831,50.0146 51.9591,48.8946 C53.2351,47.7746 53.3611,45.8326 52.2411,44.5566",
    id: "Fill-94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6859,49.458 C60.5139,48.018 58.3959,47.8 56.9559,48.972 C55.5159,50.144 55.2979,52.262 56.4699,53.702 C57.6419,55.143 59.7589,55.36 61.1999,54.187 C62.6399,53.016 62.8579,50.898 61.6859,49.458",
    id: "Fill-96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1874,57.1933 C67.9634,55.5883 65.6694,55.2793 64.0644,56.5033 C62.4594,57.7273 62.1504,60.0203 63.3754,61.6263 C64.5984,63.2313 66.8924,63.5403 68.4974,62.3163 C70.1034,61.0913 70.4114,58.7973 69.1874,57.1933",
    id: "Fill-98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8309,68.9141 C72.5549,67.1441 70.0849,66.7441 68.3149,68.0201 C66.5459,69.2971 66.1449,71.7661 67.4219,73.5361 C68.6979,75.3061 71.1669,75.7061 72.9369,74.4301 C74.7069,73.1531 75.1069,70.6851 73.8309,68.9141",
    id: "Fill-100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-125",
    transform: "translate(297.000000, 210.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0555,7.4248 C1.3005,7.3028 0.5895,7.8158 0.4675,8.5708 C0.3455,9.3248 0.8575,10.0358 1.6125,10.1578 C2.3675,10.2798 3.0775,9.7678 3.2005,9.0128 C3.3225,8.2578 2.8095,7.5468 2.0555,7.4248",
    id: "Fill-103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1752,5.959 C12.3682,5.672 11.4812,6.094 11.1942,6.9 C10.9072,7.707 11.3282,8.595 12.1352,8.881 C12.9422,9.168 13.8292,8.747 14.1162,7.94 C14.4032,7.133 13.9822,6.246 13.1752,5.959",
    id: "Fill-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2616,6.0566 C22.4026,5.6046 21.3396,5.9356 20.8876,6.7936 C20.4356,7.6536 20.7656,8.7156 21.6256,9.1676 C22.4846,9.6196 23.5466,9.2886 23.9986,8.4306 C24.4506,7.5716 24.1206,6.5086 23.2616,6.0566",
    id: "Fill-107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5092,7.2119 C31.5972,6.5949 30.3592,6.8339 29.7422,7.7449 C29.1262,8.6559 29.3642,9.8949 30.2762,10.5119 C31.1872,11.1279 32.4262,10.8889 33.0422,9.9779 C33.6592,9.0659 33.4202,7.8279 32.5092,7.2119",
    id: "Fill-109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1117,8.917 C40.1487,8.136 38.7337,8.283 37.9527,9.247 C37.1717,10.21 37.3187,11.625 38.2817,12.406 C39.2457,13.188 40.6597,13.04 41.4417,12.076 C42.2227,11.113 42.0747,9.699 41.1117,8.917",
    id: "Fill-111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.264,10.668 C48.248,9.723 46.658,9.778 45.712,10.794 C44.766,11.81 44.822,13.399 45.838,14.346 C46.853,15.292 48.443,15.235 49.389,14.221 C50.336,13.205 50.279,11.614 49.264,10.668",
    id: "Fill-113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1595,11.958 C56.0925,10.848 54.3265,10.812 53.2155,11.88 C52.1045,12.947 52.0695,14.714 53.1375,15.825 C54.2045,16.936 55.9705,16.971 57.0815,15.903 C58.1925,14.835 58.2275,13.069 57.1595,11.958",
    id: "Fill-115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9935,12.2812 C63.8735,11.0062 61.9315,10.8792 60.6565,11.9992 C59.3805,13.1192 59.2545,15.0602 60.3735,16.3372 C61.4935,17.6122 63.4355,17.7382 64.7115,16.6192 C65.9875,15.4992 66.1135,13.5562 64.9935,12.2812",
    id: "Fill-117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9598,11.1308 C71.7878,9.6908 69.6698,9.4728 68.2298,10.6448 C66.7888,11.8178 66.5718,13.9348 67.7438,15.3748 C68.9158,16.8158 71.0328,17.0328 72.4738,15.8608 C73.9138,14.6898 74.1318,12.5708 72.9598,11.1308",
    id: "Fill-119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2518,8.0019 C80.0278,6.3969 77.7338,6.0879 76.1288,7.3119 C74.5238,8.5359 74.2148,10.8289 75.4388,12.4349 C76.6628,14.0399 78.9568,14.3489 80.5618,13.1249 C82.1678,11.8999 82.4758,9.6059 81.2518,8.0019",
    id: "Fill-121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0648,2.3867 C88.7888,0.6167 86.3188,0.2167 84.5488,1.4927 C82.7788,2.7697 82.3788,5.2397 83.6558,7.0087 C84.9318,8.7787 87.4008,9.1787 89.1708,7.9027 C90.9408,6.6257 91.3408,4.1577 90.0648,2.3867",
    id: "Fill-123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-148",
    transform: "translate(308.000000, 102.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.079,82.6582 C1.325,82.5362 0.614,83.0492 0.491,83.8042 C0.369,84.5572 0.881,85.2682 1.636,85.3912 C2.391,85.5132 3.102,85.0012 3.225,84.2462 C3.347,83.4912 2.834,82.7802 2.079,82.6582",
    id: "Fill-126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2924,78.4268 C12.4854,78.1398 11.5984,78.5618 11.3114,79.3678 C11.0244,80.1748 11.4454,81.0618 12.2524,81.3488 C13.0594,81.6358 13.9464,81.2148 14.2334,80.4078 C14.5204,79.6008 14.0994,78.7138 13.2924,78.4268",
    id: "Fill-128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6527,68.5586 C18.7937,68.1066 17.7307,68.4366 17.2787,69.2956 C16.8267,70.1556 17.1567,71.2176 18.0167,71.6686 C18.8757,72.1216 19.9377,71.7906 20.3897,70.9316 C20.8417,70.0736 20.5117,69.0106 19.6527,68.5586",
    id: "Fill-130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8124,57.0068 C24.9004,56.3908 23.6624,56.6298 23.0454,57.5408 C22.4294,58.4518 22.6674,59.6908 23.5794,60.3068 C24.4904,60.9238 25.7294,60.6848 26.3454,59.7738 C26.9624,58.8618 26.7234,57.6238 25.8124,57.0068",
    id: "Fill-132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4232,47.7275 C35.4602,46.9465 34.0452,47.0935 33.2642,48.0575 C32.4832,49.0205 32.6302,50.4355 33.5932,51.2165 C34.5572,51.9985 35.9712,51.8505 36.7532,50.8865 C37.5342,49.9235 37.3862,48.5085 36.4232,47.7275",
    id: "Fill-134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6219,44.6211 C54.6069,43.6761 53.0169,43.7311 52.0699,44.7471 C51.1239,45.7631 51.1809,47.3521 52.1959,48.2991 C53.2109,49.2451 54.8019,49.1881 55.7479,48.1741 C56.6939,47.1581 56.6379,45.5671 55.6219,44.6211",
    id: "Fill-136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7802,43.9248 C70.7132,42.8138 68.9472,42.7788 67.8362,43.8468 C66.7252,44.9138 66.6902,46.6798 67.7572,47.7908 C68.8252,48.9028 70.5912,48.9368 71.7022,47.8688 C72.8132,46.8018 72.8482,45.0348 71.7802,43.9248",
    id: "Fill-138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.912,40.5137 C81.792,39.2387 79.85,39.1117 78.575,40.2317 C77.299,41.3517 77.173,43.2927 78.293,44.5697 C79.412,45.8447 81.354,45.9707 82.63,44.8517 C83.906,43.7317 84.032,41.7887 82.912,40.5137",
    id: "Fill-140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9471,33.1934 C88.7751,31.7534 86.6571,31.5354 85.2171,32.7074 C83.7771,33.8794 83.5591,35.9974 84.7311,37.4374 C85.9031,38.8784 88.0211,39.0954 89.4611,37.9234 C90.9021,36.7524 91.1191,34.6334 89.9471,33.1934",
    id: "Fill-142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8148,20.7676 C92.5908,19.1626 90.2968,18.8536 88.6918,20.0786 C87.0868,21.3016 86.7778,23.5956 88.0018,25.2006 C89.2258,26.8056 91.5198,27.1146 93.1248,25.8906 C94.7298,24.6666 95.0388,22.3726 93.8148,20.7676",
    id: "Fill-144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4442,2.041 C94.1682,0.271 91.6982,-0.129 89.9282,1.147 C88.1582,2.424 87.7582,4.894 89.0342,6.663 C90.3112,8.434 92.7802,8.833 94.5502,7.557 C96.3202,6.281 96.7202,3.812 95.4442,2.041",
    id: "Fill-146"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-171",
    transform: "translate(165.000000, 214.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.826,0.6631 C47.071,0.5411 46.36,1.0541 46.238,1.8081 C46.116,2.5621 46.628,3.2731 47.383,3.3961 C48.138,3.5181 48.849,3.0061 48.971,2.2511 C49.094,1.4961 48.581,0.7851 47.826,0.6631",
    id: "Fill-149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9755,10.4863 C47.1685,10.1993 46.2825,10.6203 45.9955,11.4273 C45.7075,12.2343 46.1295,13.1213 46.9355,13.4083 C47.7435,13.6953 48.6295,13.2743 48.9165,12.4663 C49.2045,11.6603 48.7825,10.7733 47.9755,10.4863",
    id: "Fill-151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0819,23.8642 C48.2229,23.4122 47.1609,23.7422 46.7079,24.6012 C46.2569,25.4602 46.5869,26.5232 47.4459,26.9742 C48.3049,27.4272 49.3679,27.0962 49.8189,26.2372 C50.2709,25.3792 49.9409,24.3152 49.0819,23.8642",
    id: "Fill-153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4061,36.2236 C50.4951,35.6066 49.2571,35.8456 48.6401,36.7566 C48.0231,37.6676 48.2621,38.9066 49.1731,39.5226 C50.0841,40.1396 51.3231,39.9006 51.9401,38.9896 C52.5561,38.0776 52.3171,36.8396 51.4061,36.2236",
    id: "Fill-155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9926,51.0723 C52.0296,50.2913 50.6146,50.4383 49.8336,51.4013 C49.0526,52.3653 49.1996,53.7793 50.1626,54.5603 C51.1266,55.3423 52.5406,55.1943 53.3226,54.2313 C54.1036,53.2673 53.9556,51.8533 52.9926,51.0723",
    id: "Fill-157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2386,62.9824 C50.2226,62.0374 48.6336,62.0924 47.6866,63.1084 C46.7406,64.1244 46.7966,65.7134 47.8126,66.6604 C48.8276,67.6064 50.4186,67.5494 51.3636,66.5354 C52.3106,65.5194 52.2546,63.9284 51.2386,62.9824",
    id: "Fill-159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5946,71.9707 C45.5276,70.8607 43.7616,70.8247 42.6506,71.8927 C41.5396,72.9597 41.5046,74.7267 42.5726,75.8367 C43.6396,76.9487 45.4056,76.9837 46.5166,75.9157 C47.6276,74.8477 47.6626,73.0817 46.5946,71.9707",
    id: "Fill-161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5111,78.0527 C38.3911,76.7767 36.4491,76.6507 35.1741,77.7707 C33.8981,78.8897 33.7711,80.8317 34.8911,82.1077 C36.0111,83.3837 37.9531,83.5097 39.2291,82.3897 C40.5041,81.2707 40.6311,79.3277 39.5111,78.0527",
    id: "Fill-163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4369,81.2432 C29.2649,79.8032 27.1469,79.5862 25.7069,80.7582 C24.2659,81.9302 24.0489,84.0472 25.2209,85.4872 C26.3929,86.9282 28.5099,87.1452 29.9509,85.9732 C31.3909,84.8022 31.6089,82.6832 30.4369,81.2432",
    id: "Fill-165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8226,81.5596 C18.5986,79.9556 16.3046,79.6456 14.6996,80.8706 C13.0946,82.0936 12.7856,84.3876 14.0096,85.9936 C15.2336,87.5976 17.5276,87.9076 19.1326,86.6826 C20.7376,85.4586 21.0466,83.1646 19.8226,81.5596",
    id: "Fill-167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.118,79.0186 C6.842,77.2476 4.372,76.8476 2.602,78.1236 C0.832,79.4006 0.432,81.8706 1.708,83.6396 C2.985,85.4106 5.454,85.8096 7.224,84.5346 C8.994,83.2576 9.394,80.7886 8.118,79.0186",
    id: "Fill-169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-194",
    transform: "translate(73.000000, 206.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.4471,0.9512 C106.6931,0.8282 105.9811,1.3412 105.8591,2.0962 C105.7371,2.8502 106.2491,3.5612 107.0041,3.6832 C107.7591,3.8062 108.4701,3.2942 108.5931,2.5392 C108.7151,1.7842 108.2021,1.0732 107.4471,0.9512",
    id: "Fill-172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4374,10.1318 C96.6304,9.8448 95.7434,10.2668 95.4564,11.0728 C95.1694,11.8798 95.5914,12.7668 96.3974,13.0538 C97.2054,13.3408 98.0914,12.9198 98.3784,12.1118 C98.6664,11.3058 98.2444,10.4188 97.4374,10.1318",
    id: "Fill-174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8134,16.9004 C84.9544,16.4484 83.8914,16.7784 83.4394,17.6374 C82.9884,18.4974 83.3184,19.5594 84.1774,20.0104 C85.0364,20.4634 86.0994,20.1324 86.5504,19.2734 C87.0024,18.4154 86.6724,17.3524 85.8134,16.9004",
    id: "Fill-176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9677,21.792 C74.0567,21.176 72.8187,21.414 72.2017,22.325 C71.5847,23.236 71.8237,24.476 72.7347,25.092 C73.6457,25.709 74.8847,25.47 75.5017,24.559 C76.1177,23.647 75.8787,22.409 74.9677,21.792",
    id: "Fill-178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2006,25.9053 C61.2376,25.1243 59.8236,25.2713 59.0416,26.2353 C58.2606,27.1983 58.4076,28.6133 59.3706,29.3943 C60.3346,30.1763 61.7486,30.0283 62.5306,29.0643 C63.3116,28.1013 63.1636,26.6863 62.2006,25.9053",
    id: "Fill-180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1444,28.3662 C49.1284,27.4202 47.5394,27.4752 46.5924,28.4912 C45.6464,29.5072 45.7034,31.0962 46.7184,32.0432 C47.7334,32.9892 49.3244,32.9332 50.2704,31.9182 C51.2164,30.9022 51.1604,29.3112 50.1444,28.3662",
    id: "Fill-182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0087,30.7344 C37.9407,29.6234 36.1747,29.5884 35.0637,30.6564 C33.9527,31.7234 33.9177,33.4894 34.9857,34.6004 C36.0527,35.7114 37.8197,35.7464 38.9297,34.6784 C40.0407,33.6114 40.0757,31.8444 39.0087,30.7344",
    id: "Fill-184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0018,34.5713 C27.8818,33.2963 25.9398,33.1703 24.6648,34.2893 C23.3888,35.4093 23.2628,37.3513 24.3818,38.6273 C25.5018,39.9023 27.4438,40.0293 28.7198,38.9093 C29.9958,37.7893 30.1218,35.8473 29.0018,34.5713",
    id: "Fill-186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3339,41.4404 C19.1619,40.0004 17.0439,39.7824 15.6039,40.9544 C14.1639,42.1264 13.9459,44.2434 15.1179,45.6834 C16.2899,47.1244 18.4069,47.3414 19.8479,46.1694 C21.2879,44.9984 21.5059,42.8804 20.3339,41.4404",
    id: "Fill-188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2133,52.9004 C11.9893,51.2954 9.6953,50.9864 8.0903,52.2104 C6.4853,53.4344 6.1763,55.7274 7.4013,57.3334 C8.6253,58.9384 10.9183,59.2474 12.5233,58.0234 C14.1293,56.7984 14.4373,54.5044 13.2133,52.9004",
    id: "Fill-190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85,70.5137 C6.574,68.7427 4.104,68.3427 2.334,69.6187 C0.564,70.8957 0.164,73.3657 1.441,75.1347 C2.717,76.9057 5.186,77.3057 6.956,76.0297 C8.726,74.7527 9.126,72.2837 7.85,70.5137",
    id: "Fill-192"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-217",
    transform: "translate(1.000000, 99.048000)",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.0096,38.207 C104.6326,37.542 103.7866,37.309 103.1226,37.686 C102.4576,38.063 102.2236,38.908 102.6016,39.573 C102.9786,40.238 103.8236,40.472 104.4886,40.094 C105.1546,39.717 105.3866,38.872 105.0096,38.207",
    id: "Fill-195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4628,27.8877 C99.1818,27.0787 98.2968,26.6517 97.4888,26.9337 C96.6798,27.2147 96.2528,28.0987 96.5338,28.9087 C96.8158,29.7167 97.6998,30.1437 98.5088,29.8627 C99.3168,29.5797 99.7448,28.6967 99.4628,27.8877",
    id: "Fill-197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5531,17.8691 C93.3671,16.9171 92.4441,16.2951 91.4911,16.4801 C90.5391,16.6671 89.9171,17.5901 90.1031,18.5431 C90.2891,19.4951 91.2121,20.1171 92.1651,19.9311 C93.1171,19.7451 93.7391,18.8221 93.5531,17.8691",
    id: "Fill-199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9515,8.8193 C84.8615,7.7223 83.8995,6.9073 82.8035,6.9973 C81.7065,7.0883 80.8905,8.0493 80.9805,9.1463 C81.0715,10.2423 82.0335,11.0583 83.1295,10.9673 C84.2255,10.8783 85.0415,9.9163 84.9515,8.8193",
    id: "Fill-201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0028186,3.8525 C75.0078,2.6115 74.0068,1.6015 72.7668,1.59548135 C71.5268,1.5905 70.5168,2.5915 70.5107732,3.8315 C70.5048,5.0725 71.5058,6.0815 72.7468,6.08752683 C73.9868,6.0935 74.9968,5.0925 75.0028186,3.8525",
    id: "Fill-203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0985,2.9199 C64.2005,1.5359 63.1605,0.3319 61.7755,0.2309 C60.3915,0.1289 59.1865,1.1689 59.0855,2.5539 C58.9845,3.9379 60.0245,5.1419 61.4085,5.2429 C62.7925,5.3449 63.9975,4.3049 64.0985,2.9199",
    id: "Fill-205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5448,5.71 C52.7418,4.183 51.6628,2.784 50.1348,2.587 C48.6068,2.39 47.2088,3.469 47.0108,4.997 C46.8138,6.524 47.8928,7.923 49.4208,8.12 C50.9488,8.317 52.3478,7.238 52.5448,5.71",
    id: "Fill-207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6473,11.9082 C40.9393,10.2362 39.8223,8.6432 38.1503,8.3502 C36.4783,8.0572 34.8853,9.1762 34.5923,10.8472 C34.2993,12.5192 35.4173,14.1122 37.0893,14.4052 C38.7613,14.6982 40.3543,13.5802 40.6473,11.9082",
    id: "Fill-209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.287,18.3486 C31.676,16.5326 30.518,14.7446 28.703,14.3566 C26.887,13.9676 25.1,15.1246 24.711,16.9406 C24.323,18.7566 25.479,20.5436 27.295,20.9326 C29.111,21.3216 30.898,20.1636 31.287,18.3486",
    id: "Fill-211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9364,24.2559 C21.4204,22.2959 20.2244,20.3149 18.2654,19.8299 C16.3054,19.3459 14.3244,20.5419 13.8394,22.5019 C13.3554,24.4609 14.5514,26.4429 16.5104,26.9269 C18.4704,27.4109 20.4524,26.2159 20.9364,24.2559",
    id: "Fill-213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4652,28.2119 C9.0452,26.1079 7.8102,23.9329 5.7072,23.3529 C3.6032,22.7729 1.4282,24.0079 0.8472,26.1109 C0.2672,28.2149 1.5022,30.3909 3.6062,30.9709 C5.7102,31.5509 7.8852,30.3159 8.4652,28.2119",
    id: "Fill-215"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg502Error);
export default __webpack_public_path__ + "static/media/502-error.9255a828e4f77334c86da86df8b9e926.svg";
export { ForwardRef as ReactComponent };